export default __webpack_public_path__ + "static/media/Timing.7c2a9728.png";